import { FaSquareFull, FaTimes } from "react-icons/fa";
import { LuTriangleRight } from "react-icons/lu";

import { ContractionsPerSecond } from "@/enums/ContractionsPerSecond";

const ZeroToNineTeen = () => (
	<i className="text-primary">
		<FaSquareFull />
	</i>
);

const TwentyToThirtyNine = () => (
	<i className="text-primary">
		<LuTriangleRight fill="#009ef7" />
	</i>
);

const Forty = () => (
	<i className="text-primary">
		<FaTimes />
	</i>
);

export const ContractionsPerSecondIcons = {
	ZeroToNineTeen,
	TwentyToThirtyNine,
	Forty,
	[ContractionsPerSecond.ZeroToNineTeen]: ZeroToNineTeen,
	[ContractionsPerSecond.TwentyToThirtyNine]: TwentyToThirtyNine,
	[ContractionsPerSecond.Forty]: Forty,
};
